import React, { Fragment, memo } from 'react';
import { useTranslation } from 'react-i18next';

import EmailProps from '../../proptypes/email';
import UserProps from '../../proptypes/user';
import UserSection from './UserSection';
import ProfileIcon from '../../img/icons/profile.svg';
import style from '../../style/components/overview/Profile.module.scss';

const Profile = ({ email, user }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <article className={style.top}>
        <h3 className={style.title}>
          <img alt=" " src={ProfileIcon} />
          {t('overview.myProfile')}
        </h3>
        <div className={style.content}>
          {user.uuid && <UserSection email={email} user={user} style={style} />}
        </div>
      </article>
      <section className={style.bottom} />
    </Fragment>
  );
};

Profile.propTypes = {
  email: EmailProps,
  user: UserProps,
};

Profile.defaultProps = {
  user: {},
};

export default memo(Profile);
